import { Group, Loader, Anchor } from "@mantine/core"
import React, { useState } from "react"

const handleLinkClick = (setLoading: React.Dispatch<React.SetStateAction<boolean>>, url: string) => {
  setLoading(true);
  setTimeout(() => {
    window.open(url, "_blank");
    setLoading(false);
  }, 500); // Optional delay for smooth UX
};

export const EventDate: React.FC = () => {
  const [loadingCalendar, setLoadingCalendar] = useState(false);
  
  // Generate calendar link
  const calendarLink = "https://vypfsnxifajfxzipdvtl.supabase.co/storage/v1/object/public/location/CALENDAR.ics?t=2024-12-14T00%3A33%3A56.729Z"; // Replace with your actual file URL

  return (
    <Group justify="center">
      {loadingCalendar ? (
        <Loader size="sm" color="#7fac9d" />
      ) : (
        <Anchor
          component="button"
          onClick={() => handleLinkClick(setLoadingCalendar, calendarLink)}
          style={{ color: "#7fac9d", fontWeight: 700, fontSize: "lg" }}
        >
          Saturday, January 11, 2025, 2:00 PM - 6:00 PM
        </Anchor>
      )}
    </Group>
  );
};

export const EventLocation: React.FC = () => {
  const [loadingMaps, setLoadingMaps] = useState(false);
  
  // Event details
  const address = "140 Silver Ridge Rise NW, Calgary, AB T3B 4P7";
  const googleMapsLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

  return (
      <Group justify="center">
      {loadingMaps ? (
        <Loader size="sm" color="#7fac9d" />
      ) : (
        <Anchor
          component="button"
          onClick={() => handleLinkClick(setLoadingMaps, googleMapsLink)}
          style={{ color: "#7fac9d", fontWeight: 700, fontSize: "lg" }}
        >
          140 Silver Ridge Rise NW, Calgary, AB
        </Anchor>
      )}
    </Group>
  );
};
